import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import SettingsBrightnessOutlinedIcon from '@mui/icons-material/SettingsBrightnessOutlined';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { useTheme } from './themeContext';
const options = [
  { value: 'system', label: 'System', Icon: SettingsBrightnessOutlinedIcon },
  { value: 'light', label: 'Light', Icon: LightModeOutlinedIcon },
  { value: 'dark', label: 'Dark', Icon: DarkModeOutlinedIcon },
];
export default function BookingAppearanceControl() {
  const { isBookingAppearance, bookingAppearance, setBookingAppearance } = useTheme();
  const [anchor, setAnchor] = useState(null);
  if (!isBookingAppearance) return null;
  const selected = options.find(option => option.value === bookingAppearance);
  const Icon = selected.Icon;
  return <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: { xs: 2, sm: 3 }, py: 0.5 }}>
    <Button size="small" color="inherit" startIcon={<Icon fontSize="small" />} endIcon={<ExpandMoreRoundedIcon />}
      aria-label={'Booking appearance: ' + selected.label} aria-haspopup="menu" aria-expanded={Boolean(anchor)}
      aria-controls={anchor ? 'booking-appearance-menu' : undefined}
      onClick={event => setAnchor(event.currentTarget)}
      sx={{ minHeight: 44, textTransform: 'none', color: 'text.secondary', fontWeight: 400 }}>
      Appearance
    </Button>
    <Menu id="booking-appearance-menu" anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
      MenuListProps={{ 'aria-label': 'Booking appearance' }} PaperProps={{ sx: { minWidth: 220, borderRadius: 2 } }}>
      {options.map(({value, label, Icon: OptionIcon}) => <MenuItem key={value} role="menuitemradio"
        selected={bookingAppearance === value} aria-checked={bookingAppearance === value}
        onClick={() => { setBookingAppearance(value); setAnchor(null); }}>
        <ListItemIcon><OptionIcon fontSize="small" /></ListItemIcon><ListItemText>{label}</ListItemText>
        {bookingAppearance === value && <CheckRoundedIcon fontSize="small" sx={{ ml: 2 }} />}
      </MenuItem>)}
      <Typography component="li" role="presentation" variant="caption" color="text.secondary" sx={{ px: 2, py: 1, listStyle: 'none' }}>
        Only for this booking session.
      </Typography>
    </Menu>
  </Box>;
}
